import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './seized.component.html',
  styleUrls: ['./seized.component.scss']
})
export class SeizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
